import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a377168")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.levels,
    class: "p-datatable-sm kn-table p-m-4",
    responsiveLayout: "stack",
    breakpoint: "960px"
  }, {
    empty: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withId(() => [
      _createVNode(_component_Column, {
        class: "kn-truncated",
        header: _ctx.$t('documentExecution.olap.filterDialog.level'),
        style: _ctx.olapFilterDialogDescriptor.iconColumnStyle
      }, {
        body: _withId((slotProps) => [
          _createVNode("span", null, _toDisplayString(slotProps.index + 1), 1)
        ]),
        _: 1
      }, 8, ["header", "style"]),
      _createVNode(_component_Column, {
        class: "kn-truncated",
        field: 'LEVEL',
        header: _ctx.$t('common.name'),
        key: 'name'
      }, null, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "value",
        header: _ctx.$t('documentExecution.olap.filterDialog.driverProfileAttribute'),
        key: "value"
      }, {
        body: _withId((slotProps) => [
          _createVNode(_component_Dropdown, {
            class: "olap-filter-table-dropdown",
            modelValue: slotProps.data[slotProps.column.props.field],
            "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
            options: _ctx.options,
            optionValue: "value",
            optionLabel: "label",
            optionGroupValue: "value",
            optionGroupLabel: "label",
            optionGroupChildren: "items",
            onChange: ($event: any) => (_ctx.onLevelUpdate(slotProps.data))
          }, {
            option: _withId((slotProps) => [
              _createVNode("span", null, _toDisplayString(slotProps.option.label), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        style: _ctx.olapFilterDialogDescriptor.iconColumnStyle
      }, {
        body: _withId((slotProps) => [
          _createVNode(_component_Button, {
            icon: "pi pi-trash",
            class: "p-button-link",
            onClick: ($event: any) => (_ctx.remove(slotProps.data))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["value"]))
})